import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from 'services/token/token.service';
import { EntryService } from 'services/entry/entry.service';
import { MixpanelService } from 'services/mixpanel/mixpanel.service';
import { Store } from '@ngrx/store';
import { Actions } from 'features/profiles-state/+state/profiles-state.actions';
import { requestCompleted } from '@certemy/common';
import { Selectors } from 'features/profiles-state/+state/profiles-state.state';
import { mergeMap } from 'rxjs/operators';
import { LOGIN_PROVIDER, SIGN_IN_TYPES, SIGN_UP_TYPES } from 'pages/entry/entry.helpers';
import { Actions as BrandingActions } from 'features/organization-settings/platform-branding/+state/platform-branding.actions';
import { of } from 'rxjs';
import {
  DEFAULT_LABEL_SETTINGS,
  GlobalOrganizationsLabel,
} from 'features/global-organizations-setting-state/global-organizations-setting.constant';
import { GlobalOrganizationsSettingService } from 'features/global-organizations-setting-state/global-organizations-setting.service';
import { TokenStorageService } from 'services/token/token-storage.service';
import { getErrorMessage } from 'utils/helpers';
import { MessageQueryService, SmartForm } from '@certemy/ui-components';
import _size from 'lodash-es/size';
import { OrganizationRoleRow } from 'features/organization-settings/organization-roles/organization-roles.constants';
import _sortBy from 'lodash-es/sortBy';

@Component({
  selector: 'cm-first-login',
  templateUrl: './first-login.component.html',
})
export class FirstLoginComponent implements OnInit {
  fieldvalue: any[] = [
    { label: 'First Name:', type: 'text', value: 'first_name' },
    { label: 'Last Name:', type: 'text', value: 'last_name' },
    { label: 'Email:', type: 'email', disabled: true, value: 'email' },
  ];
  profile;
  featureFlagsData;
  locations;
  organizationsLabel: GlobalOrganizationsLabel = DEFAULT_LABEL_SETTINGS;
  role: string;
  disabled: boolean = false;
  loginProvider: string;
  organizationRoles: SmartForm.FieldOption[];

  constructor(
    private token: TokenService,
    private entryService: EntryService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<any>,
    private mixpanelService: MixpanelService,
    private tokenStorage: TokenStorageService,
    private messageQueryService: MessageQueryService,
    private globalOrganizationsSettingService: GlobalOrganizationsSettingService,
  ) {}

  ngOnInit() {
    this.role = this.route.snapshot.params['role'];
    this.loginProvider = LOGIN_PROVIDER[this.route.snapshot.queryParams.loginProvider] || LOGIN_PROVIDER.CERTEMY;
    this.router.navigate([], {
      queryParams: {
        loginProvider: null,
      },
      queryParamsHandling: 'merge',
    });

    if (this.role === 'organization') {
      this.fieldvalue = [{ label: 'Organization Name:', type: 'text', value: 'organization_name' }, ...this.fieldvalue];
    }

    this.handleFormData(this.route.snapshot.data.info);
  }

  completeRegistration(event) {
    this.disabled = true;
    let request;

    event.login_provider = this.loginProvider;

    if (this.role === 'professional') {
      const message = this.entryService.getMessageType();
      if (message && message.isSelfEnrollment) {
        event.uuid = message.uuid;
        request = this.entryService.setSelfEnrollmentProfessionalRegister(event);
      } else {
        event.signUpType = SIGN_UP_TYPES.PROFESSIONAL;
        request = this.entryService.setUserRegister(event);
      }
    } else {
      event.signUpType = SIGN_UP_TYPES.ORGANIZATION;
      request = this.entryService.setUserRegister(event);
    }

    request.pipe(mergeMap(data => this.updateProfiles(data))).subscribe(
      () => {
        this.mixpanelService.register();
        this.router.navigate(['/entry/login']).catch(() => (this.disabled = false));
      },
      err => {
        console.log(err);
        this.tokenStorage.dropAllTokens();
        this.messageQueryService.addErrorMessage(getErrorMessage(err));
        this.router.navigate(['/entry/login']).catch(() => (this.disabled = false));
      },
    );
  }

  private updateProfiles(data) {
    if (data.result.token) {
      this.token.replaceUserToken(data.result.token);
      this.store.dispatch(new Actions.GetProfiles());
      this.store.dispatch(new BrandingActions.GetBrandingSettings());
      return requestCompleted(this.store.select(Selectors.profilesState));
    } else {
      this.token.userLogout();
      return of(null);
    }
  }

  private handleFormData(data) {
    if (data.code_name === 'SUCCESS') {
      const {
        showModal,
        profile,
        locations,
        featureFlagsData,
        organizationLabelSettings,
        organizationTypeId,
        organizationRoles,
      } = data.result;
      if (this.role === 'professional') {
        this.featureFlagsData = featureFlagsData;
        this.locations = locations;
        this.organizationRoles = _size(organizationRoles)
          ? organizationRoles.map((record: OrganizationRoleRow) => ({
              id: record.organizationRoleId,
              name: record.name,
            }))
          : [];
        this.organizationsLabel = this.globalOrganizationsSettingService.getLabelSettingsMapFromArr(
          organizationLabelSettings,
          organizationTypeId,
        );
        if (this.featureFlagsData.isOrganizationRolesFeatureFlagEnabled && organizationRoles.length) {
          this.fieldvalue.splice(3, 0, {
            label: 'Role:',
            type: 'select',
            value: 'organizationRoleId',
            options: _sortBy(this.organizationRoles, ['name']),
          });
        }
      }
      if (showModal) {
        this.profile = profile;
      } else {
        this.router.navigate([this.role]);
      }
    } else {
      this.router.navigate([this.role]);
    }
  }
}
